import { Coins } from "lucide-react";

export const AutoCompoundSection = () => (
  <section className="max-w-7xl mx-auto px-6 py-12">
    <div className="card-surface rounded-2xl p-10 lg:p-14 flex flex-col lg:flex-row items-start lg:items-center gap-10">
      <span className="w-14 h-14 rounded-full bg-[#1A4020] flex items-center justify-center shrink-0">
        <Coins size={22} className="text-[#00C805]" />
      </span>
      <div className="flex-1">
        <h2 className="font-heading font-bold text-lg tracking-tight">Funded by creator fees — verifiable on-chain</h2>
        <p className="text-sm text-neutral-400 leading-relaxed mt-3 max-w-2xl">
          Rewards come from the project's pons creator fees, deposited as ETH into the public
          RewardsDistributor contract. Every cycle a balance snapshot is turned into a cumulative
          Merkle root published on-chain, so anyone can independently verify that each holder's
          share is exactly their percentage of eligible supply. No custody, no promises — just math.
        </p>
      </div>
    </div>
  </section>
);
